import React from 'react';
import { LazyJoyInteractableMap } from '@shared/components/JoyInteractableMap';
import { MapPinWithMarker } from '@shared/components/JoyInteractableMap/MapPin';
import { pxToRem } from '@withjoy/joykit/theme';
import { Box } from '@withjoy/joykit';
import type { LatLngLiteral } from '@shared/core/google-maps/types';

type MapProps = Readonly<{
  eventPhoto?: string;
  destination: LatLngLiteral;
  children?: React.ReactNode;
}>;

const MapRoot: React.FC<MapProps> = ({ eventPhoto, destination, children }) => {
  return (
    <Box
      position="relative"
      width="100%"
      height="100%"
      flex={1}
    >
      <LazyJoyInteractableMap
        center={destination}
        autoCenterAndZoom
        radiusMiles={5}
        gestureHandling="cooperative"
      >
        {children}
        <MapPinWithMarker
          cardStyleOverride={{
            width: pxToRem(280),
            height: 'auto',
            padding: pxToRem(14),
            borderRadius: pxToRem(14),
            gap: pxToRem(14),
            flexDirection: 'column',
          }}
          position={destination}
          isActive={false}
          showOnTop={true}
          isCardVisible={false}
          eventPhoto={eventPhoto}
          pinSize="md"
        />
      </LazyJoyInteractableMap>
    </Box>
  );
};

const Map = React.memo(MapRoot);

Map.displayName = 'VenueMap';

export { Map };
